import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { ProcessCategory } from "../..";

@Injectable()
export class ProcessCategoryService extends BaseDataService<ProcessCategory> {
  constructor(http: HttpService) {
    super(http, "processcategory");
  }

  createInstance(options: any): ProcessCategory {
    return new ProcessCategory(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
